import { render, staticRenderFns } from "./domainNamerRenewal.vue?vue&type=template&id=5cbb2b3c&"
import script from "./domainNamerRenewal.vue?vue&type=script&lang=js&"
export * from "./domainNamerRenewal.vue?vue&type=script&lang=js&"
import style0 from "./domainNamerRenewal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports